import {Pipe, PipeTransform} from '@angular/core';
import {Moment} from 'moment-timezone';


@Pipe({
  name: 'timezone',
  standalone: false
})
export class TimeZonePipe implements PipeTransform {
  transform(ts: Moment, timezone: string | null): Moment {
    return ts ? (timezone ? ts.clone().tz(timezone) : ts) : null;
  }
}
